import { render, staticRenderFns } from "./serviceRating.vue?vue&type=template&id=2fae7893&scoped=true&"
import script from "./serviceRating.vue?vue&type=script&lang=js&"
export * from "./serviceRating.vue?vue&type=script&lang=js&"
import style0 from "@/styles/common.scss?vue&type=style&index=0&id=2fae7893&prod&lang=scss&scoped=true&"
import style1 from "./serviceRating.vue?vue&type=style&index=1&id=2fae7893&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fae7893",
  null
  
)

export default component.exports